/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GiftCardInfoQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GiftCardInfoQuery = {
  readonly __typename?: 'Query';
  readonly giftCardBalance:
    | {
        readonly __typename: 'GiftCardBalance';
        readonly customerId: string;
        readonly giftCardBalance: number;
      }
    | {
        readonly __typename: 'UnableToGetGiftCardBalanceError';
        readonly errorMessage: string;
      };
};

export const GiftCardInfoDocument = gql`
  query GiftCardInfo {
    giftCardBalance {
      __typename
      ... on GiftCardBalance {
        customerId
        giftCardBalance
      }
      ... on UnableToGetGiftCardBalanceError {
        errorMessage
      }
    }
  }
`;

export function useGiftCardInfoQuery(
  options?: Omit<Urql.UseQueryArgs<GiftCardInfoQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GiftCardInfoQuery, GiftCardInfoQueryVariables>({
    query: GiftCardInfoDocument,
    ...options,
  });
}
